import React from 'react';

import type { IClientMicrocreditListItem } from '@src/@types/clienttypes';
import { AdvertisingLink } from '@src/components/AdvertisingLink/AdvertisingLink';
import { fullDealCalculatorHasOffersData } from 'entities/FullDeal/config';
import {
  FULL_DEAL_MOBILE_APP_LINKS,
  FULL_DEAL_MOBILE_APP_SOURCE,
  FULL_DEAL_WEB_TO_WEB_LINKS,
  FULL_DEAL_WEB_TO_WEB_SOURCE,
} from 'features/FullDeal/config';
import { buildHasOfferLinkForFullDeal } from 'features/FullDeal/lib';
import styles from 'features/FullDeal/ui/FullDealCalculatorBottomSheetActions/FullDealCalculatorBottomSheetActions.module.scss';

import { PromoDealOffersActionsTexts } from '../PromoDealOfferActions/PromoDealOffersActions.texts';
import { PromoDealRedirectToAppButton } from '../PromoDealRedirectToAppButton';

interface Props {
  amount: number;
  term: number;
  offer: IClientMicrocreditListItem;
  isUserFromGoogleSearch: boolean;
}

export const PromoDealCalculatorBottomSheetActions = ({
  amount,
  term,
  offer,
  isUserFromGoogleSearch = false,
}: Props) => (
  <>
    <PromoDealRedirectToAppButton
      source={FULL_DEAL_MOBILE_APP_SOURCE.FROM_MODAL_OFFER}
      link={FULL_DEAL_MOBILE_APP_LINKS.FROM_MODAL_OFFER}
      buttonColor={isUserFromGoogleSearch ? 'blue' : 'red'}
      isUserFromGoogleSearch={isUserFromGoogleSearch}
    />

    <AdvertisingLink
      variant="secondary"
      advSub={offer.advertising.advSub}
      analytics={offer}
      linkTarget="_self"
      affSub4={fullDealCalculatorHasOffersData.affSub4}
      source={FULL_DEAL_WEB_TO_WEB_SOURCE.FROM_MODAL_OFFER}
      className={styles.advertisingLink}
      size={52}
      link={buildHasOfferLinkForFullDeal({
        link: FULL_DEAL_WEB_TO_WEB_LINKS.FROM_MODAL_OFFER,
        offerId: offer.advertising.offerId,
        amount,
        term,
        showAuth: true,
      })}
      visibleLabel={PromoDealOffersActionsTexts.continueWebsite}
      forceRedirectToFullDeal
    />
  </>
);
